<template>
  <div>
    <p class="py-4">{{ $t('message.linkUser.linkingPageDescription') }}</p>
    <div class="text-zt-danger my-2 md:my-3" v-if="executeLinkingError">
      {{ errorMessage }}
    </div>

    <zt-input outlined name="typeAccount" class="w-full my-2 py-2" v-model="email"
      :label="$t('message.loginComponent.languagesVuetify.mail')" data-vs-input="mailLinkInput" />
    <p v-if="email.length > 3 && !isValidEmail" class="text-zt-danger text-sm ml-2">{{
      $t("message.linkUser.verificationStep.invalidEmail") }}
    </p>
    <zt-input outlined name="typeAccount" class="w-full my-2 py-2" disabled readonly v-model="user"
      :label="$t('message.loginComponent.languagesVuetify.user')" data-vs-input="UserLinkInput" />
    <div class="my-4">
      <zt-tooltip :position="isMobile ? 'top' : 'right'" color="dark-300" :clickable="isMobile" outlined shadow>
        <div slot="body" class="p-3">
          <PasswordPolicies :pass-policies="passwordPolicies" />
        </div>
        <zt-input outlined :label="$t('message.settingsComponent.list.changePassword.labelPass')" type="password"
          v-model="password" />
      </zt-tooltip>
    </div>
    <finish-with-out-linking-modal :isMobile="isMobile" :noLinkingModalActive="accountsToLink.length === 0"
      @update:noLinkingModalActive="noLinkingModalActive = $event" />
  </div>
</template>

<script>
import PasswordPolicies from '@/components/generics/passwordPolicies'
import Company from '@/apiClient/Company'
import FinishWithOutLinkingModal from './FinishWithOutLinkingModal.vue'
export default {
  components: {
    PasswordPolicies,
    FinishWithOutLinkingModal
  },
  props: {
    accountsToLink: {
      type: Array,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    executeLinkingError: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      password: '',
      passwordPolicies: {},
      user: this.$store.state.user.usuario,
      email: '',

    }
  },
  created() {

    this.company = new Company()
    this.getPasswordPolicies()
  },
  computed: {
    isValidEmail() {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email)
    },
    errorMessage() {
      return this.executeLinkingError ? this.$t(`message.errorReference.${this.executeLinkingError}`) : null
    }
  },
  methods: {
    async getPasswordPolicies() {
      await this.company
        .passwordPolicies()
        .then(response => {
          this.passwordPolicies = response.data
        })
        .catch(error => { })
    },
  }
}
</script>

<style></style>